import { useMemo } from 'react';
import { TooltipWrapper } from 'components/TooltipWrapper/TooltipWrapper';
import { ENTITY, ENTITY_TO_PATH_MAP } from '../config';
import { useCreateCampaignGroupTooltip } from './useCreateCampaignGroupTooltip';
import { useShowCampaignGroupTooltip } from './useShowCampaignGroupTooltip';
import styles from '../components/CampaignGroupTooltip/CampaignGroupTooltip.module.scss';

const TOOLTIP_CONDITIONS = {
    [ENTITY_TO_PATH_MAP[ENTITY.CAMPAIGN]]: true,
    campaignOnboarding: true,
};

export const useOptionsWithTooltip = rawOptions => {
    const shouldShowTooltip = useShowCampaignGroupTooltip();
    const { tooltipContent, tooltipOptions } = useCreateCampaignGroupTooltip();
    const optionsWithTooltip = useMemo(() => {
        return rawOptions.map(option => {
            if (TOOLTIP_CONDITIONS[option.value] && shouldShowTooltip) {
                return {
                    ...option,
                    isDisabled: true,
                    label: (
                        <TooltipWrapper wrap tooltipContent={tooltipContent} tooltipOptions={tooltipOptions}>
                            <div style={{ width: '100%', color: styles.contentPrimaryBase }}>{option.label}</div>
                        </TooltipWrapper>
                    ),
                };
            }
            return option;
        });
    }, [rawOptions, shouldShowTooltip, tooltipContent, tooltipOptions]);

    return optionsWithTooltip;
};
